import { atBqnTarget, safeStr } from "common/api";

const splitColumns = (line) => line.trim().split(/\s+/);

export const parseTotalFlows = (response, bqnId) => {
  const [head, ...lines] = response.trim().split("\n");
  const fields = splitColumns(head);
  const activeIndex = fields.indexOf('ACTIVE');
  // The response of one BQN reports no BQN column, so every row is its own.
  const isOfOneBqn = fields[0] !== 'BQN';
  let result = 0;

  lines.forEach(line => {
    const values = splitColumns(line);
    const isOfBqnAsked =
      isOfOneBqn || bqnId === 'all' || Number(values[0]) === Number(bqnId);
    if(!isNaN(values[activeIndex]) && isOfBqnAsked){
      result += Number(values[activeIndex])
    }
  })

  return result;
};

// The flows of the BQN selected in the header, or of the whole cluster.

export const flowsUsageRetrieval = (mode, bqnId) =>
  ifCl.run(atBqnTarget("show flow usage", mode, bqnId));

export const flowsRetrieval = ({ subnet, lines, policy, mode, bqnId }) =>
  ifCl.run(
    atBqnTarget(
      `show flow all ${subnet || "all"}${
        policy !== "all" ? " policy " + safeStr(policy) : ""
      } full lines ${lines}`,
      mode,
      bqnId
    )
  );
